<template>
    <button :name="nome" @click="selecionarModalidade(identificadorProduto)" class="round-corner">
        <v-img class="background-produto round-corner" :src='imagemRequired'
               alt="Imóveis" />
        <v-layout class="column">
            <v-icon>{{ icone }}</v-icon>
            <h3>{{ nome }}</h3>
        </v-layout>
    </button>
</template>

<script>
  export default {
    name: 'CardProduto',
    props: {
      nome: { type: String, required: true },
      modalidade: { type: String, required: true },
      icone: { type: String, required: true },
      identificadorProduto: { required: true }
    },
    data () {
      return {
        imagemRequired: require(`../assets/img/modalidades/${this.modalidade}.jpg`)
      }
    },
    methods: {
      selecionarModalidade (identificador) {
        this.$emit('onSelecionarProduto', identificador)
      }
    }
  }
</script>

<style scoped lang="scss">
    button {
        width: 100%;
        height: 250px;
        border: none;
        position: relative;
        background: var(--dark);
        transition: all ease 500ms;
    }

    button:hover {
        background: var(--primary);
    }

    button .background-produto {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: cover;
        object-position: center;
        opacity: 0.3;
    }

    button * {
        color: #FFF !important;
        position: relative;
        z-index: 1;
    }

    button .v-icon {
        font-size: 3rem;
        margin-bottom: 10px;
    }

    button h3 {
        font-size: 1.7rem;
        white-space: normal;
    }
</style>
